<template>
<div class="vue-slider-overview">
    <div class="row">
        <div class="col-12">
            <aut-selected-vehicle
                :id="selectedVehicle.id"
                :item="selectedVehicle"
                :location-id="locationId"
                :is-business="isBusiness"
            ></aut-selected-vehicle>
        </div>
    </div>

    <div class="row mt-6 mt-xl-8">
        <div class="col-12">
            <aut-vehicle-slider
                :vehicles="vehicles"
                :selected-vehicle="selectedVehicle"
                :is-business="isBusiness"
                @vehicle-clicked="handleVehicleClicked"
            ></aut-vehicle-slider>
        </div>
    </div>
</div>
</template>

<script>
import Slider from "./Slider.vue";
import SelectedVehicle from "./SelectedVehicle.vue";

export default {
    name: "SliderOverview",

    props: ['vehicles', 'locationId', 'isBusiness'],

    components: {
        'aut-vehicle-slider': Slider,
        'aut-selected-vehicle': SelectedVehicle,
    },

    data() {
        return {
            selectedVehicle: null,
        }
    },

    created() {
        this.selectedVehicle = lodash.head(this.vehicles);
    },

    computed: {
        hasSelectedVehicle() {
            return !lodash.isNil(this.selectedVehicle)
        }
    },

    methods: {
        handleVehicleClicked(payload) {
            this.selectedVehicle = payload
        }
    },

    watch: {
        vehicles() {
            let foundVehicle = this.vehicles.find((vehicle) => (vehicle.id === this.selectedVehicle.id));

            if (!lodash.isNil(foundVehicle)) {
                this.selectedVehicle = foundVehicle;
                return;
            }

            this.selectedVehicle = lodash.head(this.vehicles);
        }
    }
}
</script>